<template>
  <div v-show="showDetails">
    <!-- <div id='overlay' @click='$emit("close-details")'></div> -->
    <div id="details">
      <header id="header" class="row">
        <div :class="`col-xs-12 monit-item bg-${statusColor}`">
          <h5 class="mb-0 pt-1">{{ Object.keys(item).length && item.NAME }}</h5>
          <div class="update">
            <clock-icon title="" /> {{ updated }}
          </div>
        </div>
        <div :class="`${isPivot ? 'col-xs-4' : 'col-xs-6'} monit-tabs ${active == 'info' ? 'active' : ''}`"
          @click="selectDetails(0)">
          Informações
        </div>
        <div :class="`${isPivot ? 'col-xs-4' : 'col-xs-6'} monit-tabs ${active == 'charts' ? 'active' : ''}`"
          @click="selectDetails(1)">
          Gráficos
        </div>
        <div v-if="isPivot" :class="`col-xs-4 monit-tabs ${active == 'agenda' ? 'active' : ''}`"
          @click="selectDetails(2)">
          Agenda
        </div>
      </header>
      <div class="column details-area  pl-2 pr-2">
        <div class="col-xs-12 content" v-if="active == 'info'">
          <center class="mt-2" v-if="isPivot">
            <pivot-dial :angle="pivotAngle(item)" :percent="pivotPercent(item)" :variant="pivotVariant(item)"
              :work-mode="pivotWorkMode(item)" :reversed="pivotReversed(item)" :pressurized="pivotPressurized(item)"
              :size="132" />
            <div :class="`pivot-status-label pivot-text-${pivotVariant(item)}`">
              {{ pivotStatusLabel(item) }}
            </div>
            <div class="pivot-status-sub">
              {{ item.MANUAL ? "Manual" : "Automático" }}
              <span v-if="pivotPercent(item) !== null"> · Percentímetro {{ pivotPercent(item) }}%</span>
              <!-- Fora de OPEN (ex: modo Local) o status geral não indica pressão —
                   out_mask/status só ecoam a config remota, não o estado físico
                   (fw_dir/pir.md). A leitura de pressão é física e vale mesmo aqui. -->
              <span v-if="!item.OPEN && pivotPressurized(item)"> · Pressurizado</span>
            </div>
          </center>
          <div v-if="isPivot && safetyFault" class="pivot-fault-box mt-2">
            <div class="pivot-fault-title"><alert-icon /> {{ safetyFault }}</div>
            <div class="pivot-fault-text">
              O DIR parou o pivô e ele só volta a seguir as agendas depois que a falha for reconhecida.
              Verifique o pivô antes de reconhecer.
            </div>
            <b-button variant="danger" size="sm" block class="mt-2"
              @click="confirmCommand('RECONHECER FALHA', () => ackFault())">
              Reconhecer falha
            </b-button>
          </div>
          <template v-if="isPivot">
            <div class="info-title mt-2">Configuração</div>
            <div class="col-xs-12 info-details">
              <div v-for="row in pivotConfigRows" :key="row.label">
                <strong>{{ row.label }}:</strong> {{ row.value }}
              </div>
              <div class="obs-info mt-1">
                <em>Sentido, modo, canhão e percentímetro vêm da agenda em execução; pressão mínima,
                  validação e filtro vêm do cadastro do atuador.</em>
              </div>
            </div>
          </template>
          <center class="mt-2" v-else>
            <div class="info-status">
              <div class="flow-status">
                <div :class="`ball bg-${statusColor}`"></div>
                <div v-if="item.OPEN" :class="`statusActuator`">
                  Ativado
                  <arrow-up-icon v-if="item.FLOW > item.MAX_FLOW" title="" />
                  <arrow-down-icon v-else-if="item.FLOW < item.MIN_FLOW" title="" />
                </div>
                <div :class="`statusActuator`" v-else>Desativado</div>
              </div>
              <div :class="`statusActuator`">
                / {{ item.MANUAL ? "Manual" : "Automático" }}
              </div>
            </div>
          </center>

          <div v-if="visibleGeneric.length && item.FLOW >= 0" class="info-title">
            Medições
          </div>
          <div class="col-xs-12 info-details mt-2">
            <div class="">
              <div v-if="item.FLOW >= 0">
                <strong>Vazão:</strong> {{ item.FLOW }} {{ item.UNIT_FLOW
                }}<br />
              </div>
              <div v-if="visibleGeneric.length" class="generic-details">
                <div v-for="(g, i) in visibleGeneric" :key="i" class="m-0">
                  <span>
                    <strong>{{ g.NAME }}</strong> {{ g.VALUE }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="info-title mt-2">Detalhes</div>
          <div class="col-xs-12 info-details">
            <strong>ID:</strong> {{ item.ID }}<br />
            <strong>Modelo:</strong> {{ item.MODEL }}<br />
            <span><strong>Dispositivo:</strong> {{ item.DIR }}</span><br />
            <span v-if="item.PUMP"><strong>Bomba:</strong> {{ item.PUMP }}<br /></span>
            <span v-if="item.HYDRO"><strong>Hidrômetro:</strong> {{ item.HYDRO }}<br /></span>
            <span v-if="item.NOTE"><strong>Observação:</strong> {{ item.NOTE }}<br /></span>
            <span v-if="item.MIN_FLOW > 0"><strong>Vazão mínima:</strong> {{ item.MIN_FLOW }}
              {{ item.UNIT_FLOW }}<br /></span>
            <span v-if="item.MAX_FLOW > 0"><strong>Vazão máxima:</strong> {{ item.MAX_FLOW }}
              {{ item.UNIT_FLOW }}<br /></span>
            <!-- item.DIR_INFO é o JSON do dispositivo (DIR) cruzado pelo backend
                 (ValveController.js, issue #456) -- substitui o bloco morto que
                 existia aqui antes, apontando pra item.DIR_DETAILS (nunca populado
                 por nenhum endpoint do sir-prod). -->
            <span v-if="item.DIR_INFO">
              <strong>Sinal:</strong> {{ dirSignal(item) !== null ? dirSignal(item) + "%" : "Sem sinal" }}<br />
            </span>
            <span v-if="item.DIR_INFO && item.DIR_INFO.BAT != null">
              <strong>Bateria:</strong> {{ item.DIR_INFO.BAT }} V<br />
            </span>
            <span v-if="item.DIR_INFO && item.DIR_INFO.VER">
              <strong>Versão de firmware:</strong> {{ item.DIR_INFO.VER }}<br />
            </span>
          </div>

          <!-- :id="`collapse-${item.ID}`" -->
          <!-- :class="visible ? null : 'collapsed'"
            :aria-expanded="visible ? 'true' : 'false'" -->
          <b-button v-if="!isPivot && !isFir" class="col-12 mt-2" variant="outline-secondary" rounded pill
            @click="visible = !visible" size="sm" :aria-expanded="visible ? 'true' : 'false'"
            :class="visible ? null : 'collapsed'">
            {{
            visible
            ? "Ocultar comandos do atuador"
            : "Exibir comandos do atuador"
            }}
          </b-button>
          <!-- PIR operado só por agenda: sem LIGAR/DESLIGAR nem comandos de
               configuração. Manual deixa o pivô parado (o fw_cir mantém STOP
               e ignora as agendas). -->
          <div v-if="isPivot" class="mb-4">
            <div class="info-title mt-2">
              Operação: {{ item.MANUAL ? "Manual" : "Automático" }}
            </div>
            <div class="obs-info mb-2">
              <em v-if="item.MANUAL">O pivô fica parado e não obedece às agendas.</em>
              <em v-else>O pivô é operado pelas agendas.</em>
            </div>
            <b-button :variant="item.MANUAL ? 'orange' : '3v3'" block size="sm"
              @click="confirmCommand(item.MANUAL ? 'MODO AUTOMÁTICO' : 'MODO MANUAL (PIVÔ PARADO)', () => manualState())">
              {{ item.MANUAL ? "Voltar para automático" : "Colocar em manual (parar o pivô)" }}
            </b-button>
            <b-button v-if="refreshButton" variant="outline-secondary" block size="sm" class="mt-2"
              @click="buttons(refreshButton.COMMAND)">
              {{ refreshButton.NAME }}
            </b-button>
          </div>
          <b-collapse v-if="!isFir && !isPivot" id="collapse-4" class="mb-1" v-model="visible">
            <p class="warning-command mt-3">
              <alert-icon /> Utilize os comandos do atuador com cuidado.
            </p>
            <!-- <div class="info-title">Comandos avançados</div> -->
            <div class="info-title mt-2">
              {{ item.MANUAL ? "Manual" : "Automático" }}
            </div>
            <div class="row middle-xs mb-1 mt-1">
              <div class="col-xs-12">
                <b-button :variant="item.MANUAL ? 'orange' : '3v3'" block
                  @click="confirmCommand(item.MANUAL ? 'MODO AUTOMÁTICO' : 'MODO MANUAL', () => manualState())"
                  size="sm">
                  ALTERAR
                </b-button>
              </div>
            </div>
            <!-- <p /> -->
            <div class="row around-xs" v-if="item.MANUAL">
              <div class="col-xs-6">
                <b-button squared variant="3v3" block @click="confirmCommand('LIGAR', () => changeStatus(1))"
                  size="sm">
                  LIGAR
                </b-button>
              </div>
              <div class="col-xs-6">
                <b-button squared variant="black" block @click="confirmCommand('DESLIGAR', () => changeStatus(0))"
                  size="sm">
                  DESLIGAR
                </b-button>
              </div>
            </div>

            <div v-else class="obs-info">
              <em>Para operar o equipamento, coloque-o em modo MANUAL.</em>
            </div>
            <div class="mb-4 mt-4">
              <div v-for="button in item.BUTTONS" :key="button.name" class="buttons">
                <b-button variant="3v3" block @click="confirmCommand(button.NAME, () => buttons(button.COMMAND))"
                  size="sm">
                  {{ button.NAME }}
                </b-button>
              </div>
            </div>
            <!-- COMMANDS -->
            <div class="middle-xs mb-1 mt-1 container-command">
              <b-input-group class="command-button row mr-0 ml-0 p-0" v-for="(btn, i) in listButtons" :key="i">
                <!-- <div class="row"> -->
                <label :for="`field-${i}`" class="label col-12 p-0 mb-1">{{ btn.LABEL }}:</label>

                <b-form-input :id="`field-${i}`" type="text" placeholder="Digite o comando" class="col-10" ref="input"
                  size="sm" />
                <b-input-group-append>
                  <!-- squared -->
                  <b-button :variant="item.MANUAL ? 'orange' : '3v3'" block class="cmd-button"
                    @click="sendButton(i, btn)" rounded size="sm">
                    <!-- {{ btn.BUTTON }} -->
                    ENVIAR
                  </b-button>
                </b-input-group-append>
                <div v-if="btn.STATUS !== ''" class="obs-info col-12 text-left p-1 mt-1 status">
                  {{ btn.STATUS }}
                </div>

                <!-- </div> -->
              </b-input-group>
            </div>
          </b-collapse>
        </div>
        <div class="col-xs-12 content" v-else-if="active == 'agenda' && isPivot">
          <pivot-schedule :item="item" />
        </div>
        <div class="col-xs-12 content chart" v-else>
          <pivot-sensor-chart v-if="isPivot" :dir-addr="item.DIR" :actuator-name="item.NAME" :is-mobile="isMobile" />
          <actuatorCharts v-else eqp="ACTUATOR" :name="item.NAME" :area="item.AREA" :is-mobile="isMobile"
            :actuator-id="item.ID" :is-pump="item.ID < 1000000" :has-feedback-sensor="hasFeedbackSensor" :columns="
            item.AREA
              ? ['FLOW', 'VOL', 'DEPTH', 'OPEN']
              : ['FLOW', 'VOL', 'OPEN']
          " :currently-values="{
              FLOW: item.FLOW,
              VOL:
                item.GENERIC.length &&
                item.GENERIC.filter((e) => e.NAME == 'VOL').length
                  ? item.GENERIC.filter((e) => e.NAME == 'VOL')[0].VALUE
                  : 0,
              OPEN: item.OPEN,
            }" :col-names="
              item.AREA
                ? [
                    {
                      value: 'FLOW',
                      text: 'VAZÃO',
                    },
                    {
                      value: 'VOL',
                      text: 'VOLUME',
                    },
                    {
                      value: 'DEPTH',
                      text: 'LÂMINA',
                    },
                    {
                      value: 'OPEN',
                      text: 'ATUAÇÃO',
                    },
                  ]
                : [
                    {
                      value: 'FLOW',
                      text: 'VAZÃO',
                    },
                    {
                      value: 'VOL',
                      text: 'VOLUME',
                    },
                    {
                      value: 'OPEN',
                      text: 'ATUAÇÃO',
                    },
                  ]
            " />
        </div>
      </div>
      <footer id="footer">
        <button size="sm" block @click="$emit('close-details')" :class="`close-button bg-${statusColor}`">
          Fechar
        </button>
      </footer>
    </div>
    <!-- Todo comando de equipamento passa por aqui antes de ser enviado — pedido
         direto do cliente após um clique acidental em campo. -->
    <b-modal v-model="confirmVisible" @ok="runPendingCommand" centered size="sm" ok-title="Confirmar"
      ok-variant="3v3" cancel-title="Cancelar" cancel-variant="outline-secondary" title="Atenção!">
      Confirmar <strong>{{ pendingLabel }}</strong> {{ isPivot ? "no pivô" : "no atuador" }}
      <strong>{{ item.NAME }}</strong>?
    </b-modal>
  </div>
</template>

<script>
import { cmd } from "@/api";
import actuatorCharts from "@/pages/monitoringPages/Actuators/components/ActuatorCharts";
import PivotDial from "./PivotDial.vue";
import PivotSensorChart from "./PivotSensorChart.vue";
import PivotSchedule from "./PivotSchedule.vue";
import {
  pivotAngle,
  pivotPercent,
  pivotVariant,
  pivotStatusLabel,
  pivotWorkMode,
  pivotReversed,
  pivotPressurized,
  pivotDirection,
  pivotCannonStatus,
  pivotPressureMin,
  pivotSafetyTimes,
  pivotSafetyFault,
  pivotRefreshButton,
} from "../pirHelpers";
export default {
  name: "actuator-details",
  components: {
    actuatorCharts,
    PivotDial,
    PivotSensorChart,
    PivotSchedule,
  },
  props: {
    item: Object,
    statusColor: String,
    isMobile: Boolean,
    updated: String,
    ending: String,
    showDetails: Boolean,
    isPivot: Boolean,
  },

  data() {
    return {
      active: "info",
      visible: false,
      confirmVisible: false,
      pendingLabel: "",
      pendingAction: null,
      // Nunca inicializado antes: "errFwRes < 5" com undefined é sempre
      // false, então getResFw() desistia na primeira tentativa sem repetir
      // (SET_MANUAL/AUTO/OPEN/CLOSE só recebem resposta do firmware depois
      // que o cmd_thread roda, a cada ~5s — a 1ª tentativa, 2s depois do
      // envio, pode chegar cedo demais).
      errFwRes: 0,
    };
  },
  watch: {
    showDetails(newValue, oldValue) {
      if (!newValue && oldValue) this.active = "info";
    },
    item(newValue, oldValue) {
      if (Object.keys(newValue).length && newValue.ID != oldValue.ID)
        this.active = "info";
    },
    isMobile() {
      this.showDetailsActuators(this.active);
    },
    active(newValue, oldValue) {
      this.showDetailsActuators(newValue);
    },
  },
  computed: {
    listButtons() {
      return this.item.INPUTS;
    },
    safetyFault() {
      return pivotSafetyFault(this.item);
    },
    refreshButton() {
      return pivotRefreshButton(this.item);
    },
    pivotConfigRows() {
      const item = this.item;
      const pct = pivotPercent(item);
      const pressureMin = pivotPressureMin(item);
      const times = pivotSafetyTimes(item);
      return [
        { label: "Sentido", value: pivotDirection(item) || "-" },
        { label: "Modo", value: pivotWorkMode(item) || "-" },
        { label: "Canhão final", value: pivotCannonStatus(item) || "-" },
        { label: "Percentímetro", value: pct !== null ? `${pct}%` : "-" },
        { label: "Pressão mínima para início", value: pressureMin ? `${pressureMin} bar` : "sem mínimo" },
        { label: "Validação na partida", value: times ? `${times.check} s` : "requer DIR D024" },
        { label: "Filtro de falha em movimento", value: times ? `${times.fault} s` : "requer DIR D024" },
      ];
    },
    hasFeedbackSensor() {
      return !!(this.item.GENERIC || []).find((g) => g.NAME === "Feedback:");
    },
    // Atuadores de modelo FIR nunca devem expor os comandos de Manual/Automático.
    isFir() {
      return !!(this.item.MODEL && this.item.MODEL.toUpperCase().includes("FIR"));
    },
    visibleGeneric() {
      const generic = this.item.GENERIC || [];
      if (!this.isPivot) return generic;
      // No PIR, Status/Percentímetro/Sentido/Modo/Canhão/Segurança já aparecem no
      // disco grande e na seção Configuração — repeti-los aqui só criaria ruído. "Pressão:"
      // (o valor em bar) e "Posição:" continuam aqui — únicas exibições delas no
      // painel de detalhes; "Pressurizado:" (Sim/Não) já vira "· Pressurizado" no
      // texto de status e a cor da gota no disco, repetir aqui seria redundante.
      const hidden = new Set([
        "Segurança:",
        "Status:",
        "Percentímetro:",
        "Sentido do movimento:",
        "Modo de funcionamento:",
        "Comando do canhão:",
        "Pressurizado:",
      ]);
      return generic.filter((g) => g.NAME && g.NAME.trim() !== "" && !hidden.has(g.NAME.trim()));
    },
  },
  methods: {
    pivotAngle,
    pivotPercent,
    pivotVariant,
    pivotStatusLabel,
    pivotWorkMode,
    pivotReversed,
    pivotPressurized,
    showComands(id) {
      console.log(this.ending);
    },
    sendButton(i, btn) {
      let newCMD = btn.CMD.concat(" ", this.$refs.input[i].$el.value);
      this.buttons(newCMD);
    },
    showDetailsActuators(active) {
      let details = document.getElementById("details");
      let header = document.getElementById("header");
      let footer = document.getElementById("footer");
      if (active == "info") {
        let width = this.isMobile ? "100%" : "361px";
        details ? (details.style.width = width) : "";
        header ? (header.style.width = width) : "";
        footer ? (footer.style.width = width) : "";
      } else if (active == "charts") {
        let width = this.isMobile ? "100%" : "calc(100% - 51px)";
        details ? (details.style.width = width) : "";
        header ? (header.style.width = width) : "";
        footer ? (footer.style.width = width) : "";
      } else if (active == "agenda") {
        let width = this.isMobile ? "100%" : "361px";
        details ? (details.style.width = width) : "";
        header ? (header.style.width = width) : "";
        footer ? (footer.style.width = width) : "";
      }
    },
    calculatePercentage(value, ref) {
      if (!ref) return 0;
      let percent = (value * 100) / ref;
      if (percent > 100) return 100;
      else if (percent < 0) return 0;
      else return parseInt(percent);
    },
    dirSignal(item) {
      const rf = item.DIR_INFO && item.DIR_INFO.RF;
      if (!rf || !rf.ack || rf.ack.length !== 2) return null;
      return this.calculatePercentage(rf.ack[0], rf.ack[1]);
    },
    selectDetails(idx) {
      let tabs = ["info", "charts", "agenda"];
      this.active = tabs[idx];
    },
    getResFw(file) {
      setTimeout((_) => {
        cmd
          .resfw(file)
          .then((ret) => {
            if (ret.status) {
              wait.hide();
              if (ret.value == "0") console.log("Sucesso na solicitação");
              else console.log("Falha na soliticação");
            } else {
              if (this.errFwRes < 5) {
                this.errFwRes++;
                console.log(
                  `Erro ao tentar ler arquivo. Tentativa: ${this.errFwRes}`
                );
                this.getResFw(file);
              } else {
                wait.hide();
                console.log("Falha na solicitação");
              }
            }
          })
          .catch((err) => {
            console.log(err);
            wait.hide();
          });
      }, 2000);
    },
    confirmCommand(label, action) {
      this.pendingLabel = label;
      this.pendingAction = action;
      this.confirmVisible = true;
    },
    runPendingCommand() {
      if (this.pendingAction) this.pendingAction();
      this.pendingAction = null;
    },
    manualState() {
      let SET = !this.item.MANUAL;
      let CMD = SET ? "SET_MANUAL" : "SET_AUTO";
      let data = { SET, CMD };
      this.changeProp(data, "actuatorsetmode");
    },
    ackFault() {
      wait.show();
      cmd
        .pirFaultAck({ ITEM: this.item.ID })
        .then((ret) => {
          wait.hide();
          alert(ret.log, ret.alert);
        })
        .catch((err) => {
          console.log(err);
          wait.hide();
        });
    },
    changeStatus(SET) {
      let CMD = SET ? "SET_OPEN" : "SET_CLOSE";
      let data = { SET, CMD };
      this.changeProp(data, "actuatorsetstate");
    },
    // Diferente de manualState/changeStatus (SET_MANUAL/AUTO/OPEN/CLOSE, que
    // o firmware confirma via set_rsp()), os comandos daqui (Atualizar, PIR_*
    // do pivô) nunca escrevem resposta em /mnt/fcir/rsp/ — não passam por
    // changeProp/getResFw, só o resultado do próprio reqofw importa.
    buttons(command) {
      let SET = true;
      let CMD = command;
      let data = { SET, CMD, ITEM: this.item.ID };
      wait.show();
      cmd
        .reqofw(data)
        .then((ret) => {
          wait.hide();
          if (!ret.status) alert(ret.log, ret.alert);
        })
        .catch((err) => {
          console.log(err);
          wait.hide();
        });
    },
    changeProp(data, apiFunction) {
      data.ITEM = this.item.ID;
      wait.show();
      cmd[apiFunction](data)
        .then((ret) => {
          if (ret.status) {
            let FILE = ret.value;
            this.getResFw({ FILE });
          } else {
            alert(ret.log, ret.alert);
            wait.hide();
          }
        })
        .catch((err) => {
          console.log(err);
          wait.hide();
        });
    },
  },
};
</script>

<style scoped>
.buttons {
  margin-top: 5px;
}

.container-command div+div {
  margin-top: 6px;
}

.warning-command {
  font-size: 0.8em;
  color: #616161;
  margin-bottom: 0px;
  padding: 8px;
  background-color: #f5f7a593;
  border-radius: 4px;
}

.warning-command .material-design-icon {
  font-size: 0.9em !important;
}

.container-command .cmd-button {
  margin-right: 0px;
}

.label {
  padding: 0;
  font-size: 0.8em;
  /* margin: 0; */
}

.status {
  background: #d0ddcca6;
  border-radius: 4px;
}

.statusActuator {
  font-size: 1.4em;
  color: #7d7d7d;
}

.pivot-status-label {
  margin-top: 8px;
  font-size: 1.3em;
  font-weight: bold;
  letter-spacing: 0.03em;
}
.pivot-status-sub {
  font-size: 0.8em;
  color: #7d7d7d;
}
.pivot-text-green {
  color: #3d9161;
}
.pivot-text-orange {
  color: #eb753e;
}
.pivot-text-gray {
  color: #5c5c5c;
}
.pivot-text-red {
  color: #b92625;
}
.pivot-text-blue {
  color: #298abe;
}

.pivot-fault-box {
  border: 1px solid #b92625;
  border-radius: 6px;
  background-color: #fbe0e0;
  padding: 8px 10px;
}
.pivot-fault-title {
  color: #b92625;
  font-weight: bold;
}
.pivot-fault-text {
  font-size: 0.85em;
  color: #6b1a1a;
}

.info-status {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ball {
  width: 0.7em;
  height: 0.7em;
  border-radius: 100%;
  margin-right: 7px;
}

.flow-status {
  display: flex;
  align-items: center;
  margin-right: 4px;
}

.obs-info {
  text-align: center;
  font-size: 0.68em;
}

.close-button {
  border: none;
  width: 100%;
  border-radius: 4px;
  color: #ffff;
  outline: none;
}

.close-button:hover {
  filter: contrast(80%);
}
</style>
